import React, { useState } from 'react';
import { Card, Table, DatePicker, Button, Space, Typography } from 'antd';
import { FileExcelOutlined, PrinterOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import useAuthStore from '../../store/useAuthStore';
import { getPurchaseRegister } from '../../api/reports.api';
import { formatCurrency, formatDate, exportToCSV } from '../../utils/formatters';

const PurchaseRegisterPage = () => {
  const { user } = useAuthStore();
  const [dates, setDates] = useState([dayjs().startOf('month'), dayjs()]);

  const { data, isLoading } = useQuery({
    queryKey: ['purchaseRegister', dates],
    queryFn: async () => {
      const res = await getPurchaseRegister(user.plantID, { from: dates[0].format('YYYY-MM-DD'), to: dates[1].format('YYYY-MM-DD') });
      // If backend returns paged result, return .items, else return as is
      if (res && Array.isArray(res.items)) return res.items;
      if (Array.isArray(res)) return res;
      return [];
    }
  });

  const columns = [
    { title: 'Bill No', dataIndex: 'billNo' },
    { title: 'Date', dataIndex: 'billDate', render: v => formatDate(v) },
    { title: 'Vendor', dataIndex: 'vendorName' },
    { title: 'Taxable', dataIndex: 'taxable', render: v => formatCurrency(v) },
    { title: 'GST', dataIndex: 'gstAmt', render: v => formatCurrency(v) },
    { title: 'Total', dataIndex: 'totalAmount', render: v => <b>{formatCurrency(v)}</b> }
  ];

  return (
    <Card title="Purchase Register">
      <Space direction="vertical" style={{ width: '100%' }}>
        <Space className="no-print" style={{ marginBottom: 16 }}>
          <DatePicker.RangePicker value={dates} onChange={setDates} />
          <Button icon={<PrinterOutlined />} onClick={() => window.print()}>Print</Button>
          <Button icon={<FileExcelOutlined />} onClick={() => exportToCSV(data || [], columns, 'PurchaseRegister')}>CSV</Button>
        </Space>
        
        <Table 
            dataSource={data || []} 
          columns={columns} 
          loading={isLoading} 
          summary={(pageData) => {
            let totalTaxable = 0, totalGst = 0, totalAmount = 0;
            pageData.forEach(({ taxable, gstAmt, totalAmount: total }) => {
              totalTaxable += taxable || 0; totalGst += gstAmt || 0; totalAmount += total || 0;
            });
            return (
              <Table.Summary.Row style={{ background: '#fafafa', fontWeight: 'bold' }}>
                <Table.Summary.Cell index={0} colSpan={3}>GRAND TOTAL</Table.Summary.Cell>
                <Table.Summary.Cell index={3}>{formatCurrency(totalTaxable)}</Table.Summary.Cell>
                <Table.Summary.Cell index={4}>{formatCurrency(totalGst)}</Table.Summary.Cell>
                <Table.Summary.Cell index={5}>{formatCurrency(totalAmount)}</Table.Summary.Cell>
              </Table.Summary.Row>
            );
          }}
        />
      </Space>
    </Card>
  );
};

export default PurchaseRegisterPage;